import { SVGProps } from "react";

const IconBuilding = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width="100%"
        height="100%"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={1.8}
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden
        {...props}
    >
        <path d="M4 21V5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v16" />
        <path d="M2 21h20" />
        <path d="M8 8h3M13 8h3M8 12h3M13 12h3M8 16h3M13 16h3" />
    </svg>
);

export default IconBuilding;
